import React from 'react';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import { ModelForm } from '../components';
import { defineAbility, subject } from '@casl/ability';
import { useHistory, useParams } from 'react-router-dom';
import PrintIcon from '@material-ui/icons/Print';
import InvoiceReturnIcon from '@material-ui/icons/AssignmentReturn';
import { useAppData } from '../contexts/appContext';
import { useUserContext } from '../contexts/userContext';

function canCreateInvoiceReturn(model, user, invoice) {
	const { ability } = model?.acl ? model.acl(user, defineAbility) : {};
	if (!ability) return true;
	return ability.can(
		'create',
		subject('Invoicereturn', { storeId: invoice.storeId })
	);
}

export default function Invoice({ formMode }) {
	const { id } = useParams();
	const history = useHistory();
	const { models } = useAppData();
	const { user } = useUserContext();
	let defaultValues = {};
	if (!id) {
		defaultValues = {
			invoiceDate: moment().toISOString(),
			partyType: 'client'
		};
	}

	return (
		<Grid container>
			<ModelForm
				recordId={id}
				formName={'invoiceLayout'}
				defaultValues={defaultValues}
				initialMode={formMode}
				isDraftable={true}
				customActionButtons={[
					{
						text: 'Print',
						startIcon: <PrintIcon />,
						color: 'primary',
						display(form) {
							return form.values.id && form.mode === 'view';
						},
						href: `/invoice/download/${id}`,
						target: '_blank'
					},
					{
						text: 'Create Return',
						startIcon: <InvoiceReturnIcon />,
						color: 'primary',
						display(form) {
							const { values } = form;
							return (
								values.id &&
								form.mode === 'view' &&
								values.status === 'active' &&
								values.invoiceStatus === 'filed' &&
								canCreateInvoiceReturn(models.invoicereturn, user, values)
							);
						},
						onClick() {
							history.push({
								pathname: '/invoicereturn',
								search: `?invoiceId=${id}`
							});
						}
					}
				]}
			/>
		</Grid>
	);
}
